'use client';

import { useEffect, useState } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { personal, navLinks } from '@/data/config';

export default function Nav() {
  const pathname = usePathname();
  const [time, setTime] = useState('');
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const update = () => {
      const opts: Intl.DateTimeFormatOptions = {
        hour: '2-digit',
        minute: '2-digit',
        timeZone: personal.timezoneIANA,
        hour12: false,
      };
      setTime(new Date().toLocaleTimeString('en-GB', opts) + ` ${personal.timezoneLabel}`);
    };
    update();
    const id = setInterval(update, 30000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  useEffect(() => {
    if (typeof document === 'undefined') return;
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  return (
    <nav className="nav" role="navigation" aria-label="Main navigation">
      <Link href="/" className="mark" aria-label={`${personal.name} — Home`}>
        {personal.name.toLowerCase()}<span className="dot" aria-hidden="true">.</span>dev
      </Link>
      <div className="links">
        {navLinks.map(({ href, label }) => (
          <Link
            key={href}
            href={href}
            className={pathname === href ? 'active' : ''}
            aria-current={pathname === href ? 'page' : undefined}
          >
            {label}
          </Link>
        ))}
      </div>
      <div className="meta" aria-label="Status">
        <span className="status-dot" aria-hidden="true" />
        {time} — {personal.status}
      </div>

      <button
        type="button"
        className={`nav-toggle${open ? ' open' : ''}`}
        aria-label={open ? 'Close menu' : 'Open menu'}
        aria-expanded={open}
        aria-controls="mobile-menu"
        onClick={() => setOpen((v) => !v)}
      >
        <span aria-hidden="true" />
        <span aria-hidden="true" />
        <span aria-hidden="true" />
      </button>

      <div
        id="mobile-menu"
        className={`mobile-menu${open ? ' open' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-hidden={!open}
      >
        <div className="mobile-menu-inner">
          {navLinks.map(({ href, label }) => (
            <Link
              key={href}
              href={href}
              className={`mobile-menu-link${pathname === href ? ' active' : ''}`}
              aria-current={pathname === href ? 'page' : undefined}
              onClick={() => setOpen(false)}
            >
              {label}
            </Link>
          ))}
          <div className="mobile-menu-meta">
            <span className="status-dot" aria-hidden="true" />
            {time} — {personal.status}
          </div>
        </div>
      </div>
    </nav>
  );
}
